export default {
  firstItemHighlighted: 'FirstItemHighlighted',
  fullWidth: 'FullWidth',
  default: 'Default',
  info: 'Info',
  slider: 'Slider',
};
